import React, { useState, useEffect, useRef, useMemo, useImperativeHandle } from 'react';
import classnamesBind from 'classnames/bind';
import { Collapse, Menu, Tooltip, Dropdown, Modal, Input } from 'antd';
import { getIn18Text } from 'api';
import { navigate } from 'gatsby';
import MailMainIcon from '@web-common/components/UI/Icons/svgs/MailMain';
import Mail163Icon from '@web-common/images/mail_163.png';
import MailQqIcon from '@web-common/images/mail_qq.png';
import MailOutlookIcon from '@web-common/images/mail_outlook.png';
import MailQiyeQQIcon from '@web-common/images/mail_qiye_qq.png';
import MailGmailIcon from '@web-common/images/mail_gmail.png';
import MailOtherIcon from '@web-common/components/UI/Icons/svgs/MailOther';
import AccountExpiredIcon from '@web-common/components/UI/Icons/svgs/AccountExpiredIcon';
import SiriusMessage from '@web-common/components/UI/Message/SiriusMessage';
import styles from './index.module.scss';
import { apiHolder as api, apis } from 'api';
import { getMainAccount } from '@web-mail/util';
const accountApi = api.api.requireLogicalApi(apis.accountApiImpl);
import useState2RM from '@web-mail/hooks/useState2ReduxMock';
import { useAppDispatch } from '@web-common/state/createStore';
import { Thunks } from '@web-common/state/reducer/mailReducer';
import LoadingOutlined from '@ant-design/icons/LoadingOutlined';
import useDebounceForEvent from '@web-mail/hooks/useDebounceForEvent';
import cloneDeep from 'lodash/cloneDeep';
const { Panel } = Collapse;
const realStyle = classnamesBind.bind(styles);
const OpenKeysIsSameActiveKey = (openKeys, activeKey) => {
    if (Array.isArray(openKeys) && Array.isArray(activeKey)) {
        if (openKeys.length !== activeKey.length) {
            return false;
        }
        const openKeysCp = cloneDeep(openKeys);
        const activeKeyCp = cloneDeep(activeKey);
        openKeysCp.sort();
        activeKeyCp.sort();
        openKeysCp.forEach((key, index) => {
            if (key !== activeKeyCp[index]) {
                return false;
            }
        });
        return true;
    }
    else {
        return openKeys === activeKey;
    }
};
const mailIconList = new Map([
    ['NeteaseQiYeMail', React.createElement(MailMainIcon, null)],
    ['163Mail', React.createElement("img", { src: Mail163Icon, className: realStyle('siriusCollapseLogo') })],
    ['Gmail', React.createElement("img", { src: MailGmailIcon, className: realStyle('siriusCollapseLogo') })],
    ['Outlook', React.createElement("img", { src: MailOutlookIcon, className: realStyle('siriusCollapseLogo') })],
    ['TencentQiye', React.createElement("img", { src: MailQiyeQQIcon, className: realStyle('siriusCollapseLogo') })],
    ['QQMail', React.createElement("img", { src: MailQqIcon, className: realStyle('siriusCollapseLogo') })],
    ['Others', React.createElement(MailOtherIcon, null)],
]);
const SiriusCollapse = React.forwardRef((props, ref) => {
    var _a;
    const { dataList, activeKey, defaultActiveKey, intermediateKey, single, showTooltip = false, openCb, closeCb, changeCb, revalidateAccountFromPanel, collapseStyle, panelStyle, operateSeparate, searchAccount, resetSearch, activeAccount, source, } = props;
    const dispatch = useAppDispatch();
    const [middleKeys, setMiddleKeys] = useState([]);
    const [mailAccountAliasMap] = useState2RM('mailAccountAliasMap');
    const [loginingSubAccountList] = useState2RM('loginingSubAccountList', 'doUpdateLoginingSubAccountList');
    const [openKeys, setOpenKeys] = useState([]);
    const [editAccountMap, setEditAccountMap] = useState({});
    const [loadingMap, setLoadingMap] = useState({});
    const nameMapRef = useRef({});
    const inputRefMapRef = useRef({});
    const [accountClickDisabledMap, setAccountClickDisabledMap] = useState({});
    const dataKeyList = useMemo(() => {
        if (dataList && dataList.length) {
            return dataList.map(d => d === null || d === void 0 ? void 0 : d.key).join('_');
        }
        else {
            return '';
        }
    }, [dataList]);
    useImperativeHandle(ref, () => ({
        closeAll: () => {
            setOpenKeys([]);
        },
    }));
    useEffect(() => {
        var _a;
        if (!openKeys.length && ((_a = dataList[0]) === null || _a === void 0 ? void 0 : _a.key) && !defaultActiveKey) {
            setOpenKeys([dataList[0].key]);
        }
    }, [dataKeyList]);
    useEffect(() => {
        if (activeKey && !OpenKeysIsSameActiveKey(openKeys, activeKey)) {
            setOpenKeys(activeKey);
        }
    }, [activeKey]);
    useEffect(() => {
        if (intermediateKey) {
            setMiddleKeys(intermediateKey);
        }
    }, [intermediateKey]);
    const goToSetting = (e, type) => {
        e.domEvent.stopPropagation();
        if (type === 'main') {
            navigate('/#setting', { state: { currentTab: 'mail' } });
        }
        if (type === 'sub') {
            navigate('/#setting', { state: { currentTab: 'mail', mailConfigTab: 'OTHER' } });
        }
    };
    const removeAccount = (e, item) => {
        e.domEvent.stopPropagation();
        const { key: agentEmail, title, type } = item;
        Modal.confirm({
            title: `是否确认移除邮箱“${title}”？`,
            content: '',
            okText: getIn18Text('SHANCHU'),
            cancelText: getIn18Text('QUXIAO'),
            width: '448px',
            okButtonProps: { 'data-test-id': 'sub-account-confirm-dialog-ok-btn' },
            centered: true,
            okButtonProps: { 'data-test-id': 'account-remove-ok' },
            onOk: async () => {
                let accountId = '';
                if (['NeteaseQiYeMail', 'qyEmail'].includes(type)) {
                    accountId = agentEmail;
                }
                else {
                    const localAccountId = accountApi.getEmailIdByEmail(agentEmail);
                    if (localAccountId) {
                        accountId = localAccountId;
                    }
                    else {
                        const bindDatas = await accountApi.getPersonalBindAccountsFromServer();
                        const targetData = (bindDatas || []).find(item => item.agentEmail === agentEmail);
                        if (targetData) {
                            accountId = targetData.accountEmail;
                        }
                    }
                }
                if (!accountId) {
                    SiriusMessage.error({ content: '移除失败' });
                }
                const params = {
                    email: accountId,
                    agentEmail,
                    accountType: ['NeteaseQiYeMail', 'qyEmail'].includes(type) ? 'qyEmail' : 'personalEmail',
                };
                try {
                    const res = await accountApi.deleteBindAccount(params);
                    if (res === null || res === void 0 ? void 0 : res.success) {
                        SiriusMessage.success({ content: '移除成功' });
                    }
                    else {
                        SiriusMessage.error({ content: res.errMsg || '移除失败' });
                    }
                }
                catch (error) {
                    console.log('移除失败 error', error);
                    SiriusMessage.error({ content: '移除失败' });
                }
            },
            onCancel(close) {
                close();
            },
        });
    };
    const reCheck = async (e, item) => {
        e.domEvent.stopPropagation();
        const { key: agentEmail, type } = item;
        let agentNickname = '';
        if (type === 'NeteaseQiYeMail') {
            agentNickname = agentEmail;
        }
        else {
            const bindDatas = await accountApi.getPersonalBindAccountsFromServer();
            const targetData = (bindDatas || []).find(item => item.agentEmail === agentEmail);
            if (targetData) {
                agentNickname = targetData.agentNickname || targetData.agentEmail;
            }
        }
        revalidateAccountFromPanel &&
            revalidateAccountFromPanel({
                accountType: ['NeteaseQiYeMail', 'qyEmail'].includes(type) ? 'NeteaseQiYeMail' : type,
                agentEmail,
                agentNickname,
            });
    };
    const disabledAccountClick = (accountName) => {
        setAccountClickDisabledMap(map => {
            return Object.assign(Object.assign({}, map), { [accountName]: true });
        });
    };
    const editAccountName = (accountName) => {
        disabledAccountClick(accountName);
        nameMapRef.current[accountName] = mailAccountAliasMap[accountName] || accountName;
        setEditAccountMap(map => {
            return Object.assign(Object.assign({}, map), { [accountName]: true });
        });
        setTimeout(() => {
            const inputRef = inputRefMapRef.current[accountName];
            if (inputRef) {
                inputRef.focus({ cursor: 'all' });
            }
        }, 200);
    };
    const accountMenu = (item, index) => {
        if (source !== 'folder')
            return React.createElement(React.Fragment, null);
        const { key, expired, isLogining } = item;
        const mainAccountId = getMainAccount();
        if (key === mainAccountId || index === 0) {
            return (React.createElement(Menu, { className: styles.accountMenu },
                React.createElement(Menu.Item, { key: "0", onClick: e => goToSetting(e, 'main'), "data-test-id": "mail-account-menu-mailsetting" }, getIn18Text('YOUXIANGSHEZHI'))));
        }
        if (isLogining) {
            return React.createElement(React.Fragment, null);
        }
        return (React.createElement(Menu, { className: styles.accountMenu, mode: "vertical" },
            React.createElement(Menu.Item, { key: "0", "data-test-id": "mail-sub-account-menu-changeshowname", onClick: e => {
                    var _a;
                    if ((_a = e === null || e === void 0 ? void 0 : e.domEvent) === null || _a === void 0 ? void 0 : _a.stopPropagation) {
                        e.domEvent.stopPropagation();
                    }
                    editAccountName(key);
                } }, getIn18Text('XIUGAIXIANSHIMINGC')),
            React.createElement(Menu.Item, { key: "1", "data-test-id": "mail-account-menu-mailsetting", onClick: e => goToSetting(e, 'sub') }, getIn18Text('YOUXIANGSHEZHI')),
            React.createElement(Menu.Item, { key: "2", "data-test-id": "mail-sub-account-menu-remove", onClick: e => removeAccount(e, item) }, getIn18Text('JIEBANG')),
            expired ? (React.createElement(Menu.Item, { "data-test-id": "account-setting-recheck", key: "3", onClick: e => reCheck(e, item) }, getIn18Text('recheck'))) : (React.createElement(React.Fragment, null))));
    };
    const onOpenChange = (openKey) => {
        if (operateSeparate) {
            return;
        }
        const openKeys = Array.isArray(openKey) ? openKey : [openKey];
        let lastestOpenKeys = openKeys;
        const len = openKeys.length;
        if (single) {
            lastestOpenKeys = openKeys[len - 1] ? [openKeys[len - 1]] : [];
            if (lastestOpenKeys[0]) {
                openCb && openCb(lastestOpenKeys[0]);
            }
            else {
                closeCb && closeCb();
            }
        }
        else {
            changeCb && changeCb(lastestOpenKeys);
        }
        setOpenKeys(lastestOpenKeys);
    };
    const openPanel = (openKey, e) => {
        if (!openKeys.includes(openKey) && operateSeparate) {
            e === null || e === void 0 ? void 0 : e.stopPropagation();
            if (single) {
                if (searchAccount != openKey && resetSearch) {
                    resetSearch(openKey, true);
                }
                setOpenKeys([openKey]);
            }
            else {
                const lastestOpenKeys = [openKey, ...openKeys];
                setOpenKeys(lastestOpenKeys);
            }
        }
    };
    const closePanel = (openKey, e) => {
        const index = openKeys.indexOf(openKey);
        if (index > -1 && operateSeparate) {
            e === null || e === void 0 ? void 0 : e.stopPropagation();
            const lastestOpenKeys = [...openKeys];
            lastestOpenKeys.splice(index, 1);
            setOpenKeys(lastestOpenKeys);
        }
    };
    const handleClickPanel = (openKey) => {
        if (!operateSeparate) {
            return;
        }
        if (intermediateKey === null || intermediateKey === void 0 ? void 0 : intermediateKey.includes(openKey)) {
            resetSearch && resetSearch(openKey);
            !openKeys.includes(openKey) && openPanel(openKey);
        }
        else if (!openKeys.includes(openKey)) {
            openPanel(openKey);
        }
    };
    const handleNodeUpdate = (key) => {
        setLoadingMap(map => {
            return Object.assign(Object.assign({}, map), { [key]: true });
        });
        dispatch(Thunks.updateUserFolderAlias({
            account: key,
            name: nameMapRef.current[key],
        })).finally(() => {
            setLoadingMap(map => {
                return Object.assign(Object.assign({}, map), { [key]: false });
            });
            setEditAccountMap(map => {
                return Object.assign(Object.assign({}, map), { [key]: false });
            });
            nameMapRef.current[key] = '';
            setTimeout(() => {
                setAccountClickDisabledMap(map => {
                    return Object.assign(Object.assign({}, map), { [key]: false });
                });
            }, 2000);
        });
    };
    const debounceHandleNodeUpdate = useDebounceForEvent(handleNodeUpdate, 500);
    const handleCancelEditNode = (key) => {
        if (nameMapRef.current) {
            nameMapRef.current[key] = '';
        }
        setEditAccountMap(map => {
            return Object.assign(Object.assign({}, map), { [key]: false });
        });
        setTimeout(() => {
            setAccountClickDisabledMap(map => {
                return Object.assign(Object.assign({}, map), { [key]: false });
            });
        }, 2000);
    };
    if (dataList.length === 1) {
        return React.createElement("div", { style: collapseStyle }, (_a = dataList[0]) === null || _a === void 0 ? void 0 : _a.children);
    }
    return (React.createElement(Collapse, { className: realStyle('siriusCollapseWrap'), style: collapseStyle, activeKey: openKeys, onChange: onOpenChange }, dataList.map((item, index) => (React.createElement(Panel, { key: item.key, header: React.createElement(Dropdown, { overlay: accountMenu(item, index), trigger: ['contextMenu'] },
            React.createElement(Tooltip, { title: showTooltip ? item.title : '', placement: "bottom" },
                React.createElement("div", { className: realStyle('siriusCollapseTitle'), "data-test-id": "mail-folder-more-btn", onClick: () => {
                        if (accountClickDisabledMap[item.key]) {
                            return false;
                        }
                        handleClickPanel(item.key);
                    } },
                    openKeys.includes(item.key) ? (React.createElement("div", { className: realStyle('siriusCollapseOpen'), onClick: e => closePanel(item.key, e) },
                        React.createElement("span", { className: `dark-invert ${realStyle('siriusCollapseIconDown')}` }))) : (React.createElement("div", { className: realStyle('siriusCollapseClose'), onClick: e => openPanel(item.key, e) },
                        React.createElement("span", { className: `dark-invert ${realStyle('siriusCollapseIconRight')}` }))),
                    React.createElement("span", { className: realStyle('siriusCollapseTitleType') }, item.isLogining ? (React.createElement(LoadingOutlined, null)) : source == 'folder' && loadingMap[item.key] ? (React.createElement(LoadingOutlined, null)) : (React.createElement(React.Fragment, null,
                        mailIconList.get(item.type) || mailIconList.get('Others'),
                        item.expired && (React.createElement("span", { className: realStyle('siriusCollapseTitleTypeExpired') },
                            React.createElement(AccountExpiredIcon, null)))))),
                    editAccountMap && editAccountMap[item.key] && source == 'folder' ? (React.createElement(React.Fragment, null,
                        React.createElement(Input, { className: realStyle('editTreeInput'), defaultValue: mailAccountAliasMap[item.key] || item.key, ref: inputref => {
                                if (inputRefMapRef.current) {
                                    inputRefMapRef.current[item.key] = inputref;
                                }
                            }, onPressEnter: e => {
                                debounceHandleNodeUpdate(item.key);
                            }, onBlur: e => {
                                debounceHandleNodeUpdate(item.key);
                            }, onClick: e => e.stopPropagation(), disabled: !!loadingMap[item.key], maxLength: 30, onChange: e => {
                                var _a;
                                if (nameMapRef.current) {
                                    const str = (_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.value.trim();
                                    nameMapRef.current[item.key] = str.slice(0, 30);
                                }
                            }, suffix: !loadingMap[item.key] ? (React.createElement("span", { className: realStyle('folderInputCancel'), onClick: () => {
                                    handleCancelEditNode(item.key);
                                } }, "\u53D6\u6D88")) : null }))) : (React.createElement(React.Fragment, null,
                        React.createElement("span", { className: realStyle('siriusCollapseTitleName') }, mailAccountAliasMap[item.key] || item.title),
                        item.count && item.count !== '0' ? (React.createElement("span", { "data-test-id": "mail-account-folder-panel-unread", className: realStyle('siriusCollapseTitleRight') }, item.count && item.count)) : (React.createElement(React.Fragment, null))))))), className: realStyle(middleKeys.includes(item.key) ? 'siriusCollapseMiddle' : item.key === searchAccount ? 'siriusCollapseSelected' : '', operateSeparate ? 'siriusCollapseNoHover' : '', activeAccount && accountApi.getIsSameSubAccountSync(activeAccount, item.key) && !openKeys.includes(item.key) ? 'avtivePanelHead' : ''), "data-test-id": "mail-account-folder-panel", style: panelStyle }, item.children)))));
});
export default SiriusCollapse;
